import { render, staticRenderFns } from "./c-alarm-chip.vue?vue&type=template&id=6b9b2384&scoped=true&"
import script from "./c-alarm-chip.vue?vue&type=script&lang=js&"
export * from "./c-alarm-chip.vue?vue&type=script&lang=js&"
import style0 from "./c-alarm-chip.vue?vue&type=style&index=0&id=6b9b2384&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b9b2384",
  null
  
)

export default component.exports